"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FalconPaymentRequest {
}
exports.default = FalconPaymentRequest;
//# sourceMappingURL=FalconPaymentRequest.js.map